export default `
  mutation requestStockNotification($email: String!, $productId: ID!, $categoryId: ID!, $categoryProduct: String!) {
    requestStockNotification(email: $email, productId: $productId, categoryId: $categoryId, categoryProduct: $categoryProduct)
  }
`;
